import React from 'react';

const SITE_NAME = 'Study Pass RDH';
const BASE_URL = 'https://app.studypassrdh.com';
const DEFAULT_IMAGE = `${BASE_URL}/studyPassLogo2.png`;

// React 19 hoists <title>/<meta>/<link> rendered anywhere in the tree into
// <head> automatically, so this can just be dropped into any page component.
function SEO({ title, description, path = '' }) {
  const fullTitle = `${title} | ${SITE_NAME}`;
  const url = `${BASE_URL}${path}`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={DEFAULT_IMAGE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />
    </>
  );
}

export default SEO;
